/* --- SHUBHAM CREATION BUY NOW LOGIC --- */
window.shubhamBuyNow = function(button) {
  const card = button.closest('.shubham-creation-product-card');
  const hiddenInput = card.querySelector('input[name="id"]');
  
  // Smart check: Does this specific product actually have size boxes?
  const hasSizes = card.querySelectorAll('.shubham-creation-size-badge').length > 0;
  let variantId = '';

  if (hasSizes) {
    if (!hiddenInput || !hiddenInput.value) {
       alert("Please select a size first!");
       return;
    }
    variantId = hiddenInput.value;
  } else {
    // If no sizes exist, grab the default fallback ID
    variantId = card.getAttribute('data-default-variant');
  }
  
  // Directly redirects to checkout with the variant ID
  window.location.href = '/cart/add?id=' + variantId + '&return_to=/checkout';
};


/* --- SHUBHAM GRID SIZE SELECTION LOGIC --- */
window.shubhamSelectSize = function(badgeElement) {
  const card = badgeElement.closest('.shubham-creation-product-card');
  
  if (badgeElement.classList.contains('shubham-creation-size-soldout')) return;

  // Remove the highlight from ALL sizes across the ENTIRE page
  document.querySelectorAll('.shubham-creation-size-badge').forEach(badge => {
    badge.classList.remove('selected'); 
  });
  
  // Highlight only the one the user just clicked
  badgeElement.classList.add('selected'); 
  
  // Update the hidden form input for this specific product card
  const variantId = badgeElement.getAttribute('data-variant-id');
  const hiddenInput = card.querySelector('input[name="id"]');
  
  if (hiddenInput) {
    hiddenInput.value = variantId;
  }
};


/* ==========================================================================
   3. AJAX NO-RELOAD ADD TO CART & OPEN DRAWER (BULLETPROOF FIX)
   ========================================================================== */
window.shubhamAddToCart = function(button) {
  const card = button.closest('.shubham-creation-product-card');
  const hiddenInput = card.querySelector('input[name="id"]');
  
  // Smart check: Does this specific product actually have size boxes?
  const hasSizes = card.querySelectorAll('.shubham-creation-size-badge').length > 0;
  let variantId = '';

  if (hasSizes) {
    if (!hiddenInput || !hiddenInput.value) {
      alert("Please select a size first!");
      return;
    }
    variantId = hiddenInput.value;
  } else {
    // If no sizes exist, grab the default fallback ID
    variantId = card.getAttribute('data-default-variant');
  }

  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;

  const formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  // STEP 1: Add the product to the cart directly via API
  fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) throw new Error('Network error');
    return response.json();
  })
  .then(() => {
    // Change button to green "Added!"
    button.textContent = 'Added!';
    button.style.backgroundColor = '#4CAF50'; 
    button.style.color = '#fff';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      button.style.backgroundColor = ''; 
      button.style.color = '';
    }, 2000);

    // STEP 2: Fetch the fresh, updated Drawer HTML from Shopify's server
    fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        
        const newInner = temp.querySelector('.drawer__inner, #CartDrawer');
        const currentInner = drawer.querySelector('.drawer__inner, #CartDrawer');
        
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        } else {
          drawer.innerHTML = html; 
        }

        drawer.classList.remove('is-empty');
        
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active', 'is-active');
        }
      }
    });

    // STEP 3: Update the little cart bubble number
    fetch('/?section_id=cart-icon-bubble')
    .then(res => res.text())
    .then(html => {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = html;
      }
    });

  })
  .catch(error => {
    console.error('Add to cart failed:', error);
    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2500);
  });
};